import React from 'react';
import { Link } from 'ice';
import styles from './index.module.scss';
import store from '@/store';
import img from '@/assets/images/logo.png';
import eImg from '@/assets/images/elogo.png';
import { getLocale } from '@/locales/locale';

export interface ILogoProps {
  image?: string;
  text?: string;
  url?: string;
}

export default function Logo({ image, text, url }: ILogoProps) {
  const [user, userDispatchers] = store.useModel('user');
  const showImg = getLocale() === 'zh-CN' ? img : eImg;
  return (
    <div className="logo">
      <Link to={url || '/'} className={styles.logo} onClick={() => userDispatchers.updateMenu({ menu: 'index' })}>
        <img src={showImg} alt="" />
      </Link>
    </div>
  );
}
